import React from 'react';
import { Helmet } from 'react-helmet';
import OffWrap from '../../components/Layout/Header/OffWrap';
import Header from '../../components/Layout/Header/Header';
import Footer from '../../components/Layout/Footer/FooterStyleOne';
import SearchModal from '../../components/Layout/Header/SearchModal';
import ScrollToTop from '../../components/Common/ScrollTop';
import ShareIdeaMain from './ShareIdeaMain';

// Images
import Logo from '../../assets/img/logo/dark-logo.png';
import footerLogo from '../../assets/img/logo/lite-logo.png';
import favIcon from '../../assets/img/fav.png';

const ShareIdea = () => {
    return (
        <React.Fragment>
            <Helmet>
                <title>Share Your Idea | Syrol Technologies</title>
                <link rel="icon" href={favIcon} />
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="pages"
                secondParentMenu="others"
                headerNormalLogo={Logo}
                headerStickyLogo={Logo}
                CanvasLogo={Logo}
                mobileNormalLogo={Logo}
                CanvasClass="right_menu_togle hidden-md"
                headerClass="full-width-header header-style1 home8-style4"
                TopBar="enable"
                TopBarClass="topbar-area home8-topbar"
                emailAddress="hello@syroltech.com"
                Location="Abuja, Nigeria"
            />

            <ShareIdeaMain />

            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />

            <SearchModal />
            <ScrollToTop scrollClassName="scrollup orange-color" />
        </React.Fragment>
    );
}

export default ShareIdea;
